export default function updatePageInPages({newPage, pages}) {
  return pages.map((page) => {
    if (page.id === newPage.id) return newPage;
    if (page.pages) page.pages = updatePageInPages({ newPage, pages: page.pages });
    return page;
  });
}